// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgTouchIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="m19.99 15.16-1 6c-.08.48-.5.84-.99.84h-8c-.23 0-.45-.08-.62-.22l-5-4a1.001 1.001 0 0 1 .79-1.77l3.67.61c.3.05.58-.03.81-.22s.35-.46.35-.76V7.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V12h.62c.38 0 .76.07 1.11.21l4.64 1.86c.44.17.69.63.62 1.09M7 8.5c.55 0 1-.45 1-1C8 5.57 9.57 4 11.5 4S15 5.57 15 7.5c0 .55.45 1 1 1s1-.45 1-1C17 4.47 14.53 2 11.5 2A5.51 5.51 0 0 0 6 7.5c0 .55.45 1 1 1" />
  </g>
);
export default SvgTouchIcon;
SvgTouchIcon.displayName = 'SvgTouchIcon';
